import Vue from 'vue'
import Vuex from 'vuex'

import config from '@/config'
import modules from './modules'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    loading: config.status.IDLE
  },
  mutations: {
    loading (state, status) {
      state.loading = status
    }
  },
  modules
})

export default store
